import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet5: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-5"><path d="M18.25 4C20.3211 4 22 5.67893 22 7.75V8.5H17.25C15.7312 8.5 14.5 9.73122 14.5 11.25V12.75C14.5 14.2688 15.7312 15.5 17.25 15.5H22V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75C2 5.67893 3.67893 4 5.75 4H18.25Z" fill="currentColor"/><path d="M16 11.25C16 10.5596 16.5596 10 17.25 10H21.75C22.4404 10 23 10.5596 23 11.25V12.75C23 13.4404 22.4404 14 21.75 14H17.25C16.5596 14 16 13.4404 16 12.75V11.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconWallet5;
